import { createArray, createCell, random } from 'helpers';
import { foods as foodsSetup, map as mapSetup } from 'setup';
import Entity from '../Entity';
import Nature from '../Nature/Nature';

export default class Ant extends Entity {

    colony: Nature;
    props: EntityBaseProps & AntProps;
    setup: EntityBaseSetup & AntSetup;

    atParadise = false;

    constructor(gameState: GameState, type: AntType, setup: EntityBaseSetup & AntSetup, props?: EntityBaseProps & AntProps, state?: any) {
        // Get props
        props = {
            idleTexture: `ant/${type}/ant-${type}.png`,
            movingTextures: createArray(12, i => `ant/${type}/ant-${type}-moving-${i + 1}.png`),
            ...props,
        };

        // Call super
        super(gameState, 'ant', type, setup, props, state);

        // Initialize
        this.colony = gameState.entities.natures.active.find(nature => nature.type === 'antColony') as Nature;
        this.props = props;
        this.setup = setup;
        this.x = (props?.x || (random(-1, 1, true) + this.colony.cell.x)) * mapSetup.cells.size;
        this.y = (props?.y || (random(-1, 1, true) + this.colony.cell.y)) * mapSetup.cells.size;
        this.zIndex = 3;
    }

    onMove = () => {
        this.gameState.revealFog(this.cell, this.setup.revealDistance || 1);
    }

    /** Move to paradise corner */
    moveToParadise = () => {
        // Move to paradise
        const paradiseCell = createCell(foodsSetup.cheese.x, foodsSetup.cheese.y);
        paradiseCell.x += random(-2, 2, true);
        paradiseCell.y += random(-2, 2, true);
        this.moveTo(paradiseCell, 0, () => {
            this.atParadise = true;
        });
    }

    getMovingSpeed = () => {
        return (this.setup.movingSpeed || 1) * (this.gameState.entities.ants.buffs.speed + 1);
    }

}